import { css as o } from "@microsoft/fast-element";
import { normalize as r } from "../common/normalize.js";
import { display as e } from "@matrix42/fast-foundation";
import { designTokens as i } from "../design-tokens.js";
const d = o`
  ${r}
  ${e("inline-block")}
  :host {
    /* Base */
    vertical-align: middle;
  }

  .control {
    /* Base */
    display: block;
    height: 100%;
    width: 100%;
    user-select: none;
    /* Style */
    border-radius: ${i.borderRadius.full};
  }
`;
export {
  d as avatarStyles
};
